var showroomsControls = {
    init : function(){
        $('.showroom-actions .toggle').click(function($e){
            var _this = $(this);
            if(!_this.hasClass('modal')){
                if(_this.parent().hasClass('open')){
                    _this.parent().removeClass('open');
                }else{
                    $('.showroom-actions ul li.open').removeClass('open');
                    _this.parent().addClass('open');
                }
                $e.preventDefault();
            }
        });
        try{
            $('.showroom-actions').bind( "clickoutside", function(){
            $('.showroom-actions .toggle').parent().removeClass('open');
        });
        }catch(e){
            console.log(e); 
        }       

        $('.showroom-actions .showroom-controls  .dropdown-toggle').click(function($e){
            var $this = $(this);
            $('.lvl-3-block.open').removeClass('open');
            if($this.parent().hasClass('open')){
                $this.parent().removeClass('open');
            }else{
                $('.showroom-actions .showroom-controls  .dropdown-toggle').parent().removeClass('open');
                $this.parent().addClass('open');
            }
            $e.preventDefault();
        });
    },
   
   
     showroomStandAlias : function(e){
        var setup_alias =$(e).find('div.popContentLeft').data('alias');
        var setup_title =$(e).find('div.popContentLeft').data('title');
        var setup_url =  $(e).find('div.popContentLeft').data('url');

        showroomsNavigation(setup_url,setup_title,setup_alias);
    },

     showroomNavigationAlias : function(e){
        var setup_alias =$(e).data('alias');
        var setup_title =$(e).data('title');
        var setup_url =  $(e).data('url');

        showroomsNavigation(setup_url,setup_title,setup_alias);
    },
    
     showroomBackAlias : function(e){
        var setup_alias = $(e).data('alias');
        var setup_title =$(e).data('title');
        var setup_url =  $(e).data('url');
        showroomsNavigation(setup_url,setup_title,setup_alias);

    },

    fullScreen : function(t){
        $('body').toggleClass('fullscreen');

        if($('body').hasClass('fullscreen')){
             $('.exit-fullscreen').show();
             $('.enter-fullscreen').hide();
        }else{
            $('.enter-fullscreen').show();
            $('.exit-fullscreen').hide();
        }

        $.toggleFS(t);
        $(t).find('.icon').toggleClass('hidden');
        $(window).trigger('resize');
    },

};


$(document).ready(function(){
	initShares();
     var lastScrollTop = 0;
      var window_width = $(window).width() + 17;
     $(document).on('scroll',function() {
        _scrollTop = $(window).scrollTop();
       
        if( $('.showrooms-cta').length>0 && window_width < 991){
          if ( _scrollTop > 200){
             $('.showrooms-cta').addClass('slide-up');
           } else {
              $('.showrooms-cta').removeClass('slide-up');
           }

            if($(window).scrollTop() + $(window).height() == $(document).height()) {
                $('.showrooms-cta').removeClass('slide-up');
           }

           lastScrollTop = _scrollTop;
        }


    });

      if( $('.showrooms-cta').length>0 && window_width < 991){
          var   _scrollTop = $(window).scrollTop();
          if ( _scrollTop > 200){
             $('.showrooms-cta').addClass('slide-up');
           } else {
              $('.showrooms-cta').removeClass('slide-up');
           }

            if($(window).scrollTop() + $(window).height() == $(document).height()) {
                $('.showrooms-cta').removeClass('slide-up');
           }

           lastScrollTop = _scrollTop;
      }

    $.is_fs = false;
    $.requestFullScreen = function(calr)
    {
        var element = document.body;
        // Supports most browsers and their versions.
        var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;
        if (requestMethod) { // Native full screen.
            requestMethod.call(element);
        } else if (typeof window.ActiveXObject !== "undefined") { // Older IE.
            var wscript = new ActiveXObject("WScript.Shell");
            if (wscript !== null) {
                wscript.SendKeys("{F11}");
            }
        }

        $.is_fs = true;
        $(calr).val('Exit Full Screen');
    }

    $.cancel_fs = function(calr)
    {
        var element = document; //and NOT document.body!!
        var requestMethod = element.exitFullScreen || element.mozCancelFullScreen || element.webkitExitFullScreen || element.mozExitFullScreen || element.msExitFullScreen || element.webkitCancelFullScreen;

        if (requestMethod) { // Native full screen.
            requestMethod.call(element);
        } else if (typeof window.ActiveXObject !== "undefined") { // Older IE.
            var wscript = new ActiveXObject("WScript.Shell");
            if (wscript !== null) {
                wscript.SendKeys("{F11}");
            }
        }

        $(calr).val('Full Screen');
        $.is_fs = false;
    }

    $.toggleFS = function(calr)
    {
        $.is_fs == true? $.cancel_fs(calr):$.requestFullScreen(calr);
    }
	
});

function showroomsNavigation($url,$title,$alias){
  if($('.stand-details').length>0){

          $('.showroom-actions .home').removeClass('hidden');
           var location = $url.split('/showrooms/').filter(Boolean);
           if($url!== URL+'showrooms/'){
                if(location[1].length>0){
                    var subcategory = location[1].split('/').filter(Boolean);
                    $.ajax({
                        data: {
                            module: 'showrooms',
                            action: "get_category_template",
                            alias: subcategory[0]
                        },
                        success: function(data) {
                            if(data.redirect){
                                window.location.replace(data.redirect);
                            }
                            if(data.markup){

                                 if($('#social_dialog').length){
                                   $('#social_dialog').remove();
                                 }
                                 
                                document.title = $title+' | Virtual Showroom | Thrace Group';
                                $('.stand-details').fadeOut("slow", function(){
                                   var div = $(data.markup).hide();
                                   $(this).replaceWith(div);
                                    window.history.pushState ({"html":"","pageTitle":$title},"", $url);
                                   $('.stand-details').fadeIn("slow");
                                   
                                  if(data.category_data.parent==='main'){
                                    var $parent_title = data.category_data.parent_name;
                                    if ( typeof(data.category_data.url_params.active_site.language_code)!== 'undefined' && data.category_data.url_params.active_site.language_code!='en' && typeof(data['category_data']['parent_name_'+data.category_data.url_params.active_site.language_code])!=='undefined' && data['category_data']['parent_name_'+data.category_data.url_params.active_site.language_code]!=='' ) {
                                        $parent_title = data['category_data']['parent_name_'+data.category_data.url_params.active_site.language_code];
                                    }
                                    if(data.category_data.parent==='main'){
                                     $('.showroom-actions .home,.showroom-actions .back').addClass('hidden');
                                    }


                                    $('.showroom-nav .back-action a').data('url',URL+'showrooms/' );
                                    $('.showroom-nav .back-action a').data('title',$parent_title);
                                    $('.showroom-nav .back-action a').data('alias',data.category_data.parent);
                                  }else{
                                    var $parent_title = data.category_data.parent_name;
                                    if ( typeof(data.category_data.url_params.active_site.language_code)!== 'undefined' && data.category_data.url_params.active_site.language_code!='en' && typeof(data['category_data']['parent_name_'+data.category_data.url_params.active_site.language_code])!=='undefined' && data['category_data']['parent_name_'+data.category_data.url_params.active_site.language_code]!=='' ) {
                                        $parent_title = data['category_data']['parent_name_'+data.category_data.url_params.active_site.language_code];
                                    }
                                     $('.showroom-nav .back-action a').data('url',URL+'showrooms/'+data.category_data.parent_alias );
                                     $('.showroom-nav .back-action a').data('title',$parent_title);
                                     $('.showroom-nav .back-action a').data('alias',data.category_data.parent_alias);
                                  }
                                       
                                });
                               
                                
                            }
                        }
                    });

                }
                
            }else if($url===URL+'showrooms/'){
                 $.ajax({
                        data: {
                            module: 'showrooms',
                            action: "get_category_template",
                            alias: ''
                        },
                        success: function(data) {
                            if(data.markup){

                                if($('#social_dialog').length){
                                   $('#social_dialog').remove();
                                 }
                               window.history.pushState ({"html":"","pageTitle":'Thrace Group Showroom | Member of Thrace Group '},"", $url);
                                $('.stand-details').fadeOut("slow", function(){
                                   var div = $(data.markup).hide();
                                   $(this).replaceWith(div);
                                   $('.stand-details').fadeIn("slow");
                                   $('.showroom-actions .home,.showroom-actions .back').addClass('hidden');
                                   $('.showroom-nav .back-action a').data('url',URL+'showrooms/');
                                   $('.showroom-nav .back-action a').data('title','Thrace Group Showroom | Member of Thrace Group');
                                   $('.showroom-nav .back-action a').data('alias','main');

                                });
                               
                                
                            }
                        }
                    });

            }
        }
}

var _rtime = new Date();
var _timeout = false;
var _delta = 300;
function showRoomsProducts(){
  $(window).resize(function() {
    "use strict";
    _rtime = new Date();
      if (_timeout === false) {
          _timeout = true;
          setTimeout(function(){ 
             var total_height=$('.product-info-details-wrapper .product-title').innerHeight();
            $('.product-info-details-wrapper .info-group').each(function( index ) {
                  total_height +=$(this).innerHeight();
             });
              if(total_height < 600){
                $('.product-info-details-wrapper').addClass('expanded');
                $('.expand-btn').hide();
            }else{
               $('.product-info-details-wrapper').removeClass('expanded');
               $('.expand-btn').show();
            }
             _timeout = false;
          }, _delta);


      }
  });
  var total_height=$('.product-info-details-wrapper .product-title').innerHeight();
  $('.product-info-details-wrapper .info-group').each(function( index ) {
        total_height +=$(this).innerHeight();
   });
  
  if(total_height < 600){
      $('.product-info-details-wrapper').addClass('expanded');
      $('.expand-btn').hide();
  }else{
     $('.product-info-details-wrapper').removeClass('expanded');
     $('.expand-btn').show();
  }
   
   $('.switch-view').click(function() {
        $(this).parent().toggleClass('alternative-image');
        if( $(this).parent().hasClass('alternative-image') ){
            $('#main-image').hide();
            $('#alt-image').show();
            $(this).parent().find('.hidden-label').show();
            $(this).parent().find('.visible-label').hide();

            $(this).parent().find('.hidden-svg').removeClass('hidden');
            $(this).parent().find('.visible-svg').addClass('hidden');

        }else{
            $('#alt-image').hide();
            $('#main-image').show();
            $(this).parent().find('.hidden-svg').addClass('hidden');
            $(this).parent().find('.visible-svg').removeClass('hidden');
            $(this).parent().find('.visible-label').show();
            $(this).parent().find('.hidden-label').hide();
        }
        return false;
    });

    $('.related-image').click(function() {
        var parent = $(this).parent().parent().data('index');
        $('.related-item-product').each(function( index ) {
            if(index !== parent){
                $(this).find('.popuptext').removeClass('show');
            }

        });
        $(this).parent().children('.popuptext').toggleClass('show');
        return false;
    });

     $('body').click(function() {
        $('.related-image').each(function( index ) {
          $(this).parent().children('.popuptext').removeClass('show');
        });
    });
}

function initShares(){
	"use strict";
	var clipboard = new Clipboard('.clipboardButton');
	clipboard.on('success', function(e) {		
		$('.clipboardButton .copy-label').text(' Copied!');
		e.clearSelection();
	});
	clipboard.on('error', function(e) {
		console.error('Action:', e.action);
		console.error('Trigger:', e.trigger);
		
	});	
}

 function initMeetingForm() {


    
    $('form[name="meeting-form"]').validate({
      submitHandler: function () {
        $.ajax({data: $('form[name="meeting-form"]').serialize(),
          success: function (data) {
            if (data.status == "ok") {
              $('#meeting_dialog .alert-success').show();
              setTimeout(function(){ 
                window.location.reload();    
              }, 3000);


            } else {
              alert(data.error);
            }
          }
        });
        return false;
      },
      rules: {
        name: "required",
        company_name: "required",
        job_position: "required",
        email: {
          required: true,
          email: true
        },
        country: "required",
        message: "required"
      },
      messages: {
        name: " ",
        company_name: " ",
        job_position: " ",
        email: " ",
        country: " ",
        message: " "
      },
      highlight: function (element, errorClass, validClass) {
        if($(element).is(':radio')){
          $(element).parent().parent().addClass(errorClass);
        }else{
          $(element).parent().addClass(errorClass);
        }


      },
      unhighlight: function (element, errorClass, validClass) {
        if($(element).is(':radio')){
          $(element).parent().parent().removeClass(errorClass);
        }else{
          $(element).parent().removeClass(errorClass);
        }
      },
      
      errorPlacement: function (error, element) {
        element.parent();
      }
    });
  }

  
  function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};